var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgItalic18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.943 16l.361-1.71h2.973L9.53 3.697H6.556l.37-1.71h8.008l-.37 1.71h-2.973L9.338 14.29h2.973l-.36 1.71H3.942z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiPjxwYXRoIGQ9Ik0zLjk0MyAxNmwuMzYxLTEuNzFoMi45NzNMOS41MyAzLjY5N0g2LjU1NmwuMzctMS43MWg4LjAwOGwtLjM3IDEuNzFoLTIuOTczTDkuMzM4IDE0LjI5aDIuOTczbC0uMzYgMS43MUgzLjk0MnoiLz48L3N2Zz4=";
export { SvgItalic18 as ReactComponent };